{
	"description": "Entitlement Template for Jira Product Discovery Standard",
	"features": [
		{
			"featureId": "provided-allowances",
			"domain": "BILLING",
			"value": {
				"allowances": [
					{
						"reference": "allowance_automation-credits",
						"type": "ALLOWANCE",
						"config": {
							"usageKey": "automation-credits",
							"cycles": [
								{
									"schedule": "BILLING",
									"cycle": "MONTHLY",
									"amount": 300,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "user"
									}
								},
								{
									"schedule": "BILLING",
									"cycle": "ANNUAL",
									"amount": 300,
									"relativeTo": {
										"referenceType": "CHARGE_ELEMENT",
										"referenceValue": "user"
									}
								}
							],
							"isConsumer": false,
							"recipientEntity": "POOL"
						}
					}
				]
			}
		}
	]
}
